export default {
  computed: {
    linesType() { return this.currentTurretProperty("lines_type", "yardage") },
    snapToClicks() { return this.currentTurretProperty("snap_to_clicks", false) },
    revolutionConfigurations() { return this.currentTurretProperty("revolutuion_configurations", []) },
  },
  methods: {
    currentTurretProperty(name, fallback) {
      if (this.currentScope && this.currentScope !== "other") {
        return this.currentScope.turret[name]
      } else {
        return fallback
      }
    }
  }
}
